import { ORIENTATION, Tab, Tabs } from 'baseui/tabs-motion'
import { Card, tabOverrides, tabsOverrides } from './styled-components'
import useAdditionalSalesContainer from './useAdditionalSalesContainer'
import SaleElement from './SaleElement'
import { capitalize } from '@/shared/tools/stringFunctions'
import TitleV2 from './bones/Title'
import FilterSales from './bones/FilterSales'

// import useAdditionalSaleFormData from './useAdditionalSaleFormData'

const AdditionalSalesContainer = () => {
  const {
    t,
    getSaleTab,
    selectedSales,
    hideComponent,
    activeTab,
    setActiveTab,
    hasZohoIdAdditionalSale,
    renderTabTitle,
    groupConfig,
    updateGroupVisibility,
    zohoSaleType = 'sales',
    isBlockedIfMcpCreated = false,
    searchValue,
    setSearchValue,
  } = useAdditionalSalesContainer()

  // const { showOnlyAllowLeadMcp } = useAdditionalSaleFormData() todo-v2: check this
  const showOnlyAllowLeadMcp = false // wip
  const titleV2 = t('additionalSales:common.container_title_v2')

  if (hideComponent) {
    return ''
  }

  return (
    <Card style={{ display: 'flex', flex: '1 1 100%', flexDirection: 'row' }}>
      <div style={{ display: 'flex', flex: '1 1 30%', flexDirection: 'column' }}>
        <TitleV2 hidden={!titleV2} text={titleV2} />
        <FilterSales searchValue={searchValue} setSearchValue={setSearchValue} t={t} />
        {Object.keys(groupConfig).map(group => {
          const visibility = groupConfig[group].visible || searchValue?.length > 0
          const keys = groupConfig[group].keys || []
          return (
            <>
              <p
                style={{ fontWeight: 'bold' }}
                onClick={() => updateGroupVisibility(group)}
                id={'tab-'.group}
                key={group}
              >
                {renderTabTitle(t('additionalSales:common.tab_title_' + group), visibility)}
              </p>
              <Tabs
                activeKey={activeTab}
                onChange={({ activeKey }) => setActiveTab(activeKey)}
                orientation={ORIENTATION.vertical}
                overrides={tabsOverrides(selectedSales.includes(activeTab))}
              >
                {visibility &&
                  keys.map(key => {
                    const title = t('additionalSales:titles.' + key)
                    const lowerTitle = title?.toLowerCase() || ''
                    if (searchValue && searchValue?.length > 0 && !lowerTitle.includes(searchValue.toLowerCase())) {
                      return null
                    }
                    return (
                      <Tab
                        title={getSaleTab(key)}
                        key={key}
                        id={'tab-' + key}
                        overrides={tabOverrides(activeTab === key, hasZohoIdAdditionalSale(key))}
                      >
                        <p></p>
                      </Tab>
                    )
                  })}
              </Tabs>
            </>
          )
        })}
      </div>
      {activeTab !== '' && (
        <div style={{ flex: '1 1 100%', marginLeft: '20px' }}>
          <SaleElement
            path={capitalize(activeTab) + 'Sale'}
            vaType={zohoSaleType}
            isBlockedIfMcpCreated={isBlockedIfMcpCreated && showOnlyAllowLeadMcp}
          />
        </div>
      )}
    </Card>
  )
}

export default AdditionalSalesContainer
